/**
 * I18nProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import { useTranslation } from 'react-i18next'

import I18nContext from './i18n-context'

export default function I18nProvider({ children }) {
  const {
    // t,
    i18n
  } = useTranslation()

  function handleChangeLanguage(localeCode) {
    i18n.changeLanguage(localeCode)
  }

  return (
    <I18nContext.Provider
      value={{
        currentLanguage: i18n.language,
        changeLanguage: handleChangeLanguage
      }}
    >
      {children}
    </I18nContext.Provider>
  )
}
